// src/Routes.jsx
import { Routes, Route } from 'react-router-dom';
import App from './App';
import ServicesPage from './pages/ServicesPage';
import SupportPage from './pages/SupportPage';
import AboutPage from './pages/AboutPage';
import CoveragePage from './pages/CoveragePage';
import CareersPage from './pages/CareersPage';
import ContactPage from './pages/ContactPage';
import LegalPage from './pages/LegalPage';
import DevicesPage from './pages/DevicesPage';

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/services" element={<ServicesPage />} />
      <Route path="/support" element={<SupportPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/coverage" element={<CoveragePage />} />
      <Route path="/careers" element={<CareersPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/devices" element={<DevicesPage />} />
      <Route path="/legal/:type" element={<LegalPage />} />
    </Routes>
  );
}